customElements.define("quick-add", class QuickAdd extends HTMLElement{
    constructor(){
        super()

        this.atcBtn = this.querySelector('.js-add-to-cart')
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.variantRadios = this.querySelector("variant-radios")
        this.currentVariantId = parseInt(this.dataset.defaultVariant)
        this.closeQuickAddBtn = this.querySelector('.js-close-quick-add')

        this.variantRadios.addEventListener("change", (e)=>{
            this.currentVariantId = this.variantRadios.currentVariant.id
        })

        this.closeQuickAddBtn && this.closeQuickAddBtn.addEventListener("click", ()=>{
            this.classList.remove("active")
        })



        //Add to cart that variant
        this.atcBtn.addEventListener("click", ()=>{
            if(this.classList.contains('active') || this.querySelector('.quick-add--single-variant')){
                this.addToCart()
            }else{
                this.classList.add("active")
            }
        })
    }

    addToCart(){
        this.atcBtn.classList.add("loading")
        const data = {
            items: [
                {
                    id: this.currentVariantId,
                    quantity: 1
                }
            ]
        }

        fetch(window.Shopify.routes.root + 'cart/add.js?sections=cart-drawer,cart-icon-bubble', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            return response.json();
          })
        .then(response=>{
            this.cart.renderContents(response);
        })
        .catch((error) => {
            console.error('Error:', error);
        })
        .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.atcBtn.classList.remove("loading")
            this.classList.remove("active")
        });
    }
})